import * as React from 'react';

import type { InvoiceAlertsContextValue } from './InvoiceAlertsContext.types';

import { InvoiceAlertsContext } from './InvoiceAlertsProvider';

export function useInvoiceAlertsData(): InvoiceAlertsContextValue {
  const context = React.useContext(InvoiceAlertsContext);

  if (!context) {
    throw new Error(
      'useInvoiceAlertsData must be used within InvoiceAlertsProvider'
    );
  }

  return context;
}
